interface OnboardingAnswer {
  question_key: string
  question: string
  answer_key: string
  answer: string
}

const STORAGE_KEY = 'onboarding_answers'

export function saveAnswer(key: string, answer: OnboardingAnswer) {
  try {
    const answers = getAllAnswers()
    answers[key] = answer
    localStorage.setItem(STORAGE_KEY, JSON.stringify(answers))
  } catch (error) {
    console.error('Error saving answer:', error)
  }
}

export function getAllAnswers(): Record<string, OnboardingAnswer> {
  try {
    const answers = localStorage.getItem(STORAGE_KEY)
    return answers ? JSON.parse(answers) : {}
  } catch (error) {
    console.error('Error getting answers:', error)
    return {}
  }
}
